/* eslint-disable */
import type { LocalizableString } from "../../cash/localization/localization.pb";

export interface RewardSelection {
  token?: string;
  reward_token?: string;
  version?: number;
  unlock_in_progress?: RewardSelectionUnlockInProgress | undefined;
  active?: RewardSelectionActive | undefined;
  disabled?: RewardSelectionDisabled | undefined;
}

export interface RewardSelectionActive {
}

export interface RewardSelectionDisabled {
}

export interface RewardSelectionUnlockInProgress {
  /** Plain progress text. */
  progress_text?: string;
  /** Markdown styled progress text */
  styled_progress_text?: string;
  localizable_progress_text?: LocalizableString;
  localizable_styled_progress_text?: LocalizableString;
  progress_bar?: RewardSelectionUnlockInProgressProgressBar | undefined;
}

export interface RewardSelectionUnlockInProgressProgressBar {
  current?: number;
  target?: number;
  type?: RewardSelectionUnlockInProgressProgressBarType;
}

export enum RewardSelectionUnlockInProgressProgressBarType {
  DISCRETE = "DISCRETE",
  CONTINUOUS = "CONTINUOUS",
}
